import * as React from 'react';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import { Box, ModalClose, Textarea, Typography } from '@mui/joy';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import { toast } from 'react-toastify';

export default function FeedbackModals({ open, setOpen, handleClose }: any) {
    // const [open, setOpen] = React.useState<boolean>(true);
    const [isSending, setIsSending] = React.useState<boolean>(false);
    const [starNum, setStarNum] = React.useState<any>();
    const [feedbackText, setFeedbackText] = React.useState<any>();

    const onHandleAddFeedback = async () => {
        if (starNum === 0) {
            toast.error("Rating is required.");
            return;
        }
        const payload = {
            rating: starNum,
            remarks: feedbackText,
            app_route: "BTS",
            process: "Employee Login",
            user_id: localStorage.getItem("employee_id"),
            user_type: localStorage.getItem("userRole")
        };

        try {
            setIsSending(true);
            const response = await fetch("http://10.1.0.62:5011/create_feedback", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            // Use response.text() if your API doesn't return JSON
            setIsSending(false);
            const data = await response.json();
            if (data.status) {
                toast.success(data.message);
                setOpen(false);
                handleClose();
            }

            return data;
        } catch (error) {
            setIsSending(false);
            console.error("Error submitting feedback:", error);
            throw error;
        }
    }

    // console.log(feedbackText)

    return (
        <React.Fragment>
            <Modal open={open} onClose={() => { setOpen(false); handleClose(); }}>
                <ModalDialog variant="outlined" role="alertdialog">
                    <ModalClose />
                    <DialogTitle>
                        Your Feedback
                    </DialogTitle>
                    <Divider />
                    <DialogContent>
                        <Box>
                            <Typography>What is you think about BTS</Typography>
                            <Box sx={{ display: 'flex', gap: '20px', margin: '5px 0px' }}>
                                {
                                    [1, 2, 3, 4, 5].map((item, index) => {
                                        if (starNum >= item) {
                                            return <StarIcon key={"sdf" + index} sx={{ transform: 'scale(2)', margin: '10px', cursor: 'pointer', color: 'blue' }} onClick={() => setStarNum(item)} />
                                        } else {
                                            return <StarBorderIcon key={"sdf" + index} sx={{ transform: 'scale(2)', margin: '10px', cursor: 'pointer' }} onClick={() => setStarNum(item)} />
                                        }
                                    })
                                }
                            </Box>

                            <Typography>Do you have any thoughts you'd like to share?</Typography>
                            <Box sx={{ display: 'flex', gap: '20px', margin: '5px 0px' }}>
                                <Textarea
                                    value={feedbackText}
                                    onChange={(e: any) => setFeedbackText(e.target.value)}
                                    minRows={5}
                                    maxRows={5}
                                    placeholder="Try to submit with text!"
                                    sx={{ mb: 1, width: '100%', background: 'white' }}
                                />
                            </Box>
                        </Box>

                    </DialogContent>
                    <DialogActions>
                        <Button disabled={isSending} variant="solid" color="primary" onClick={() => onHandleAddFeedback()}>
                            {isSending ? 'Sending...' : 'Submit'}
                        </Button>
                        <Button disabled={isSending} variant="plain" color="neutral" onClick={() => { setOpen(false); handleClose(); }}>
                            Cancel
                        </Button>
                    </DialogActions>
                </ModalDialog>
            </Modal>
        </React.Fragment>
    );
}